// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Forbidden_error__SArPQ {\n  display: flex;\n  margin-top: 6rem;\n  font-weight: bold;\n  color: var(--color-red);\n  justify-content: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Navigation/Forbidden.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB","sourcesContent":[".error {\n  display: flex;\n  margin-top: 6rem;\n  font-weight: bold;\n  color: var(--color-red);\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": "Forbidden_error__SArPQ"
};
export default ___CSS_LOADER_EXPORT___;
